/**
 * Theme toggle: light → dark → system.
 *
 * `system` is deliberately part of the cycle rather than a hidden default, so
 * a user who wants to follow their OS can get back to it.
 */

import { useUiStore } from '../../stores/uiStore.js';
import styles from './ThemeToggle.module.css';

const ORDER = ['light', 'dark', 'system'];

const ICONS = {
  light: (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle cx="10" cy="10" r="4" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M10 1.5v2M10 16.5v2M18.5 10h-2M3.5 10h-2M16 4l-1.4 1.4M5.4 14.6 4 16M16 16l-1.4-1.4M5.4 5.4 4 4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  ),
  dark: (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M17 12.3A7.5 7.5 0 0 1 7.7 3a7.5 7.5 0 1 0 9.3 9.3Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  ),
  system: (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <rect x="2.5" y="3.5" width="15" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.6" />
      <path d="M7 16.5h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
};

const LABELS = {
  light: 'Light theme',
  dark: 'Dark theme',
  system: 'Follow system theme',
};

export function ThemeToggle({ className = '' }) {
  const theme = useUiStore((state) => state.theme);
  const setTheme = useUiStore((state) => state.setTheme);

  const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length];

  return (
    <button
      type="button"
      className={`${styles.toggle} ${className}`}
      onClick={() => setTheme(next)}
      aria-label={`${LABELS[theme]}. Switch to ${LABELS[next].toLowerCase()}.`}
      title={LABELS[theme]}
    >
      {ICONS[theme]}
    </button>
  );
}
